import * as types from '../mutation-types'
const state = {
  userDetails: { profilePhotoUrl: 'static/assets/images/dummy.png', confirmStatus: false, fullName: '' },
  loading: false
}
const getters = {
  getuserDetails (state) {
    return state.userDetails
  },
  getLoader: function (state) {
    return state.loading
  }
}
const mutations = {
  [types.STORE_PROFILE_USER_DETAILS] (state, data) {
    state.userDetails = data
  },
  [types.STORE_PROFILE_USER_PHOTO] (state, data) {
    state.userDetails.profilePhotoUrl = data
  },
  [types.STORE_PROFILE_USER_NAME] (state, data) {
    state.userDetails.fullName = data
  },
  [types.STORE_CONFIRM_STATUS] (state, data) {
    state.userDetails.confirmStatus = data
  },
  [types.STORE_LOADING] (state, data) {
    state.loading = data
  }
}
const actions = {
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js